<script>
import Endpoints from '../../../../components/common/Endpoints';
import Common from '../../../../components/common/Common';
import Request from '../../../../components/common/Request';
import { mapActions } from 'vuex'

export default {
    init: async(payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');

    },
  methods:{
    filter: async function(){
      let responseTruckVuc = (await Request.do(this, 'POST', Request.getDefaultHeader(this),{fileName : "Trucks",collectionName : "trucks",filters:{vehicleType: "TRUCK_VUC",status:"ACTIVE"}}, `${Endpoints.systemUsers.count}`)).data;
      let responseTruckToco = (await Request.do(this, 'POST', Request.getDefaultHeader(this),{fileName : "Trucks",collectionName : "trucks",filters:{vehicleType: "TRUCK_TOCO",status:"ACTIVE"}}, `${Endpoints.systemUsers.count}`)).data;
      let responseTruckTruck = (await Request.do(this, 'POST', Request.getDefaultHeader(this),{fileName : "Trucks",collectionName : "trucks",filters:{vehicleType: "TRUCK_TRUCK",status:"ACTIVE"}}, `${Endpoints.systemUsers.count}`)).data;
      let responseTruckMHSimples = (await Request.do(this, 'POST', Request.getDefaultHeader(this),{fileName : "Trucks",collectionName : "trucks",filters:{vehicleType: "TRUCK_MECHANICAL_HORSE_SIMPLE",status:"ACTIVE"}}, `${Endpoints.systemUsers.count}`)).data;
      let responseTruckMHTrucado = (await Request.do(this, 'POST', Request.getDefaultHeader(this),{fileName : "Trucks",collectionName : "trucks",filters:{vehicleType: "TRUCK_MECHANICAL_HORSE_TRUCADO",status:"ACTIVE"}}, `${Endpoints.systemUsers.count}`)).data;
      let responseTruckMHTracado = (await Request.do(this, 'POST', Request.getDefaultHeader(this),{fileName : "Trucks",collectionName : "trucks",filters:{vehicleType: "TRUCK_MECHANICAL_HORSE_TRACADO",status:"ACTIVE"}}, `${Endpoints.systemUsers.count}`)).data;
      //let responseTotalTruck = (await Request.do(this, 'POST', Request.getDefaultHeader(this), 
      //{fileName: "Trucks",collectionName: "trucks",status:"ACTIVE",vehicleTypes:["TRUCK_VUC", "TRUCK_TOCO" ,"TRUCK_TRUCK","TRUCK_MECHANICAL_HORSE_SIMPLE",
      //"TRUCK_MECHANICAL_HORSE_TRUCADO","TRUCK_MECHANICAL_HORSE_TRACADO"]}, `${Endpoints.systemUsers.count}`)).data;

      this.total = responseTruckVuc.count+responseTruckToco.count+responseTruckTruck.count+responseTruckMHSimples.count+responseTruckMHTrucado.count+responseTruckMHTracado.count;

      if (responseTruckVuc.status==200 && responseTruckToco.status==200 && responseTruckTruck.status==200 && responseTruckMHSimples.status==200 && responseTruckMHTrucado.status==200 && responseTruckMHTracado.status==200){
        this.chart.data.datasets[0].data = [responseTruckVuc.count,responseTruckToco.count,responseTruckTruck.count,responseTruckMHSimples.count,responseTruckMHTrucado.count,responseTruckMHTracado.count];
        this.chart.update(); 
      }
    } 
  } 
}
</script>
